import styled from "styled-components";

export const CartContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  max-width: 17rem;
  padding: 1rem;

  p {
    padding-bottom: 0.5rem;
    color: rgba(67, 67, 67, 0.75);
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 500;
  }

  div:first-of-type {
    border-bottom: none;
  }

  .cartContent {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;
    width: 100%;
    gap: 0.5rem;

    img {
      width: 5rem;
      margin-top: 0.5rem;
      margin-left: 0.5rem;
    }

    h3 {
      width: 15rem;
      font-size: 1.125rem;
      line-height: 1.25rem;
      margin-left: 0.5rem;
      font-style: normal;
      font-weight: 500;
      color: #212121;
    }

    p {
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 400;
      color: #616161;
      margin-left: 0.5rem;
    }

    span {
      color: #460259;
      font-weight: 700;
      line-height: 1.25rem;
      padding-bottom: 0.5rem;
      margin-left: 0.5rem;
    }
  }

  .subtotal {
    text-align: end;
    font-weight: 700;
    padding-top: 0.875rem;
    line-height: 1.25rem;
    padding-bottom: 0.5rem;
    color: #460259;
  }
`;
